import { render } from "./DesktopMenu.vue?vue&type=template&id=141961c7"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maxime/Documents/Projects/Ombrage/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__